<template>
  <div
    :class="[`shrimp-banner-${stylesVariant}`]"
    @click="!sideDrawer && goToPool()"
  >
    <div :class="[`shrimp-banner-${stylesVariant}__background-gradient`]">
      <img
        alt="background"
        class="image-gradient"
        src="@/assets/banners/moomoo-banner.jpg"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useRouter } from 'vue-router';
import { computed } from 'vue';

const props = defineProps({
  sideDrawer: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const emits = defineEmits(['cancel']);
const router = useRouter();

const goToPool = () => {
  router.push({
    name: 'swap',
    query: {
      from: '0x1::aptos_coin::AptosCoin',
      to: '0xc5fbbcc4637aeebb4e732767abee8a21f2b0776f73b73e16ce13e7d31d6700da::MOOMOO::MOOMOO',
      curve: 'unstable',
      version: '0.5',
      target: 'swap',
    },
  });
  onClose();
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const stylesVariant = computed(() => {
  return props.sideDrawer ? 'short' : 'full';
});

function onClose() {
  emits('cancel');
}
</script>

<style lang="scss" scoped>
.shrimp-banner-full {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 84px;
  border-radius: 10px;
  background: #abaeff21;
  cursor: pointer;
  overflow: hidden;

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 84px;
  }
}

.shrimp-banner-short {
  display: flex;
  position: relative;
  width: 100%;
  height: 51px;
  margin-bottom: 10px;
  align-items: center;
  border-radius: 10px;
  background: #abaeff21;
  gap: 15px;
  overflow: hidden;

  @media (max-width: 400px) {
    gap: 0;
  }

  &__background-gradient {
    position: absolute;
    width: 100%;
    height: 51px;
  }
}

.image-gradient {
  height: 100%;
  width: 100%;
}
</style>
